/* eslint-disable */
/* eslint-disable no-underscore-dangle */
import { cacheKey } from 'appConstants';

const { TOKEN, LL_TOKEN, CLOUD_ENV, PROVIDERS, USER_NAVBAR_PREFS, SEND_METHOD } = cacheKey;

// This is a terrible name. Should've been named to Cache. -Amir
class WindowStorage {
  constructor() {
    this.get = this.get.bind(this);
    this.set = this.set.bind(this);
    this.remove = this.remove.bind(this);
    this.removeItems = this.removeItems.bind(this);
    this.clear = this.clear.bind(this);
    this.getToken = this.getToken.bind(this);
    this.setToken = this.setToken.bind(this);
    this.setUserNavPreference = this.setUserNavPreference.bind(this);
    this.getUserNavPreference = this.getUserNavPreference.bind(this);
    this._storage = 'localStorage';
    this._accountId = null;
    // Data that's added/removed within the app (i.e. not from third party libs)
    this._webItems = new Set([TOKEN, LL_TOKEN, CLOUD_ENV, PROVIDERS]);
    this._alwaysLocalStorageItems = new Set([SEND_METHOD, USER_NAVBAR_PREFS]);
    this.timeoutIds = [];
    this.setSessionStorage = () => {
      this._storage = 'sessionStorage';
    };
  }

  get(key) {
    // CloudEnv could be in localStorage even though _storage is set to sessionStorage.
    // This is due to dependencies on the Angular app.
    if (key === CLOUD_ENV) {
      return localStorage.getItem(CLOUD_ENV) ?? sessionStorage.getItem(CLOUD_ENV);
    }
    const value = window[this._storage].getItem(key);
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  set(key, value) {
    let v = value;
    if (typeof value !== 'string') {
      v = JSON.stringify(value);
    }
    if (this._alwaysLocalStorageItems.has(key)) {
      localStorage.setItem(key, v);
    } else {
      window[this._storage].setItem(key, v);
    }
  }

  remove(key) {
    if (this._webItems.has(key)) {
      window[this._storage].removeItem(key);
    }
  }

  removeItems(keys, storageEngine) {
    keys.forEach((key) => {
      if (this._webItems.has(key)) {
        window[storageEngine].removeItem(key);
      }
    });
  }

  // Removes all web-app specific items
  clear() {
    const sessionStorageItems = Object.keys(sessionStorage);
    const localStorageItems = Object.keys(localStorage);
    this.removeItems(sessionStorageItems, 'sessionStorage');
    this.removeItems(localStorageItems, 'localStorage');
    this._accountId = null;

    // clear all lingering setTimeouts
    while (this.timeoutIds.length) {
      clearTimeout(this.timeoutIds.pop());
    }
  }

  setToken(value) {
    let tokenType = TOKEN;
    if (this._storage === 'localStorage') {
      tokenType = LL_TOKEN;
    }
    this.set(tokenType, value);
  }

  getToken() {
    let token = sessionStorage.getItem(TOKEN);
    if (token) {
      this._storage = 'sessionStorage';
    } else {
      token = localStorage.getItem(LL_TOKEN);
    }
    return token;
  }

  setUserNavPreference(userName, value) {
    let userNavbarPreferences = {};
    if (localStorage.getItem(USER_NAVBAR_PREFS)) {
      userNavbarPreferences = JSON.parse(localStorage.getItem(USER_NAVBAR_PREFS));
      userNavbarPreferences[userName] = value;
    } else {
      userNavbarPreferences[userName] = value;
    }
    localStorage.setItem(USER_NAVBAR_PREFS, JSON.stringify(userNavbarPreferences));
  }

  getUserNavPreference() {
    let userNavbarPreferences = localStorage.getItem(USER_NAVBAR_PREFS);
    if (userNavbarPreferences) {
      userNavbarPreferences = JSON.parse(userNavbarPreferences);
    }
    return userNavbarPreferences;
  }

  set auth0(flag = false) {
    this.auth0Flag = flag;
  }

  get auth0() {
    return this.auth0Flag;
  }

  set timeout(timeoutId) {
    this.timeoutIds.push(timeoutId);
  }

  get timeout() {
    return this.timeoutIds;
  }

  set accountId(accountId) {
    this._accountId = accountId;
  }

  get accountId() {
    return this._accountId;
  }
}

export const windowStore = new WindowStorage();
